<template>
  <component :is="getLayout">
    <slot/>
  </component>
</template>

<script>
    import adminMainLayout from "@/views/layout/adminMainLayout.vue";
    import adminLayout from "@/views/layout/adminLayout.vue";
    import adminLoginLayout from "@/views/layout/adminLoginLayout.vue";

    import userMainLayout from "@/views/layout/userMainLayout.vue";
    import userLayout from "@/views/layout/userLayout.vue";
    


export default {
  name: "LayoutView",
  components: {
    adminMainLayout,
    adminLayout,
    adminLoginLayout,
    userLayout,
    userMainLayout
  },
  computed: {
    getLayout: function () {
      
      //console.log("@@@@ this.$route : %o",this.$route);      
      // Layout 정보
      let layout = this.$route.meta.layout;
      //console.log("@@@@ layout : "+layout);      
      return layout;
    },
  },
};
</script>